import { Injectable } from '@angular/core';
import { ProductService } from './product.service';
import { ProductInfo } from '@app-model/product';

@Injectable({
  providedIn: 'root'
})
export class UtmService {

  private productInfo: ProductInfo;

  constructor(private productService: ProductService) {
    this.productService.getProductInfo().subscribe(p => this.productInfo = p);
  }

  addUtmToUrl(url: string, cardCanonicalUrl: string): string {
    if (url) {
      try {
        let urlObj = new URL(url);
        urlObj.searchParams.set('utm_source', this.productInfo.name);
        if (cardCanonicalUrl) {
          urlObj.searchParams.set('utm_term', cardCanonicalUrl);
        }
        return urlObj.toString();
      } catch (error) {
        return url;
      }

    }

    return url;
  }
}
